export const DATE_FORMAT = 'DD.MM.YYYY';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const TOTAL_DAYS_PER_MONTH_VIEW = 42;
export const WEEKDAYS = ['Mo.', 'Tu.', 'We.', 'Th.', 'Fr.', 'Sa.', 'Su.'];
export const DATE_MONTH_DAY_YEAR_FORMAT = 'MM-DD-YYYY';
export const DATE_YEAR_MONTH_DAY_FORMAT = 'YYYY-MM-DD';
export const DATE_READABLE_MONTH_YEAR_FORMAT = 'MMMM YYYY';
export const TIME_PICKER_STEP = 15;